import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { HomeHero } from "@/components/home/HomeHero";
import { HomeServices } from "@/components/home/HomeServices";
import { HomeProjects } from "@/components/home/HomeProjects";
import { OfferBanner } from "@/components/home/OfferBanner";
import { HomeWhy } from "@/components/home/HomeWhy";
import { Proprietor } from "@/components/home/Proprietor";
import { Capabilities } from "@/components/home/Capabilities";
import { EstimateForm } from "@/components/home/EstimateForm";

const LINKS = [
  { label: "Services", target: "#services" },
  { label: "Projects", target: "#projects" },
  { label: "Capabilities", target: "#capabilities" },
  { label: "Why us", target: "#why" },
  { label: "$5K Kitchen Offer", to: "/offer", accent: true },
];

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Nav links={LINKS} cta={{ label: "Request free estimate", short: "Free estimate", target: "#estimate", testId: "nav-estimate-btn" }} />
      <main>
        <HomeHero />
        <HomeServices />
        <HomeProjects />
        <OfferBanner />
        <HomeWhy />
        <Proprietor />
        <Capabilities />
        <EstimateForm />
      </main>
      <Footer />
    </div>
  );
}
